import { Config, Network, defaultConfig } from '@breeztech/breez-sdk-spark';

/**
 * Build a Breez SDK Config from environment and persisted user settings.
 * Pure function — no side effects beyond reading env vars and localStorage.
 */
export function buildConnectConfig(): Config {
  const network = import.meta.env.VITE_BREEZ_NETWORK ?? 'mainnet';
  const config: Config = defaultConfig(network as Network);
  config.apiKey = import.meta.env.VITE_BREEZ_API_KEY ?? '';
  config.lnurlDomain = import.meta.env.VITE_BREEZ_LNURL_DOMAIN ?? 'pay-spark.cluborange.org';
  config.maxDepositClaimFee = { type: 'networkRecommended', leewaySatPerVbyte: 50 }

  // Apply persisted user settings to config
  try {
    config.preferSparkOverLightning = true;
  } catch (e) {
    console.error('Failed to apply user settings to config', e);
  }

  return config;
}